import { cn, Skeleton } from "@nexus/ui";

import { PERSONA_OPPORTUNITY_SET_GRID_CLASS } from "../../../lib/persona-opportunity-grid-classes.js";

export interface PersonaOpportunitiesLoadingStateProps {
  className?: string;
}

export function PersonaOpportunitiesLoadingState({ className }: PersonaOpportunitiesLoadingStateProps) {
  return (
    <div className={cn("flex min-h-0 flex-1 flex-col gap-4 overflow-hidden p-4", className)}>
      <div className="flex shrink-0 items-center gap-2">
        <Skeleton className="h-8 w-[220px] rounded-md" />
        <Skeleton className="h-8 w-40 rounded-md" />
      </div>
      <div className={PERSONA_OPPORTUNITY_SET_GRID_CLASS}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="min-h-32 rounded-md" />
        ))}
      </div>
    </div>
  );
}
